export default [
	{
		key: 'timestamp',
		label: 'Date/Time',
		sorteable: true
	},
	{
		key: 'description',
		label: 'Beta Feature',
		sorteable: false
	},
	{
		key: 'actions',
		label: 'Action',
		sorteable: false
	},
	{
		key: 'changedByUserName',
		label: 'Changed By',
		sorteable: true
	}
];
